// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jNbaZagoDRkRfoJt{overflow:hidden;height:49px}.jNbaZagoDRkRfoJt.kecFcCRi_Yk2TEGV .nt1H5fyJjx0fHR36 a{color:var(--py-neutral-8)}.jNbaZagoDRkRfoJt::after{content:"";position:absolute;bottom:0;left:0;width:100%;height:1.5px;background-color:var(--py-neutral-8);opacity:0;transition:opacity 300ms,transform 300ms;transform:translate3d(-100%, 0, 0)}.jNbaZagoDRkRfoJt:hover:not(.fGUJsWV8zBoFxqCc):after,.jNbaZagoDRkRfoJt.kecFcCRi_Yk2TEGV::after{opacity:1;transform:translate3d(0, 0, 0)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navOption": `jNbaZagoDRkRfoJt`,
	"active": `kecFcCRi_Yk2TEGV`,
	"linkText": `nt1H5fyJjx0fHR36`,
	"selected": `fGUJsWV8zBoFxqCc`
};
export default ___CSS_LOADER_EXPORT___;
